import jackpotImage from '@assets/images/coin-race/race/jackpot.png';
import cupImageCompleted from '@assets/images/coin-race/race/prize-big-completed.png';
import cupImage from '@assets/images/coin-race/race/prize-big.png';

import { COIN_RACE_TYPE } from '@types';

export const formatDateRange = (startDate: string, endDate: string): string => {
	const start = new Date(startDate);
	const end = new Date(endDate);

	const startDay = String(start.getDate()).padStart(2, '0');
	const startMonth = String(start.getMonth() + 1).padStart(2, '0');
	const endDay = String(end.getDate()).padStart(2, '0');
	const endMonth = String(end.getMonth() + 1).padStart(2, '0');

	return `${startDay}.${startMonth}-${endDay}.${endMonth}`;
};

export const formatDuration = (seconds: number, t: any): string => {
	const hours = seconds / 3600;
	const days = seconds / (3600 * 24);
	const weeks = seconds / (3600 * 24 * 7);

	if (weeks >= 1) {
		return `${Math.floor(weeks)} ${t('weeks.short')}`;
	}

	if (days >= 1) {
		return `${Math.floor(days)} ${t('days.short')}`;
	}

	return `${Math.floor(hours)} ${t('hours.short')}`;
};

export const getBannerImage = (type: COIN_RACE_TYPE, isCompleted?: boolean) => {
	if (isCompleted) {
		return cupImageCompleted;
	}
	if (type === COIN_RACE_TYPE.JACKPOT_PRIZE) {
		return jackpotImage;
	}
	return cupImage;
};

export const getClockColorByDuration = (durationSeconds: number): string => {
	const hours = durationSeconds / 3600;

	if (hours <= 6) return '#297AFF';
	if (hours <= 12) return '#AE66FF';
	if (hours <= 24) return '#FF5E3A';
	return '#47D7AC';
};
